import * as XLSX from 'xlsx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ResponseTyperReports, ResponseUSer } from 'src/app/_models';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { fromEvent, Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}
export interface columns {
  column: string;
  title: string;
}

/** Constants used to fill up our data base. */
const COLORS: string[] = [
  'maroon',
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'purple',
  'fuchsia',
  'lime',
  'teal',
  'aqua',
  'blue',
  'navy',
  'black',
  'gray',
];
const NAMES: string[] = [
  'Maia',
  'Asher',
  'Olivia',
  'Atticus',
  'Amelia',
  'Jack',
  'Charlotte',
  'Theodore',
  'Isla',
  'Oliver',
  'Isabella',
  'Jasper',
  'Cora',
  'Levi',
  'Violet',
  'Arthur',
  'Mia',
  'Thomas',
  'Elizabeth',
];

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
})
export class ReportsComponent implements OnInit, AfterViewInit, OnDestroy {
  tab3=false;
  dataReportType:ResponseTyperReports
  mySubscription: any;
  currentUser: ResponseUSer;
  viewTable = false;
  FromDate = false;
  datosName: columns;
  columns: columns[];
  ArrayDataReport: MatTableDataSource<any>;
  ArrayDataReport2 = [];
  DatosReporte: ResponseTyperReports;
  htmlDate = false;
  Searchtxt = '';
  ToDate = false;
  SearchIn = false;
  Customer = [];
  typeReport: ResponseTyperReports[];
  selected: any;
  selected2 = 'option2';
  displayedColumns: string[];
  dataSource = [];
  From: Date;
  To: Date;
  fecha = new Date();
  date = new FormControl(new Date());
  date2 = new FormControl(
    new Date(this.fecha.setMonth(this.fecha.getMonth() - 1))
  );
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TableViewPaginator')
  TableViewPaginator: MatPaginator;
  @ViewChild('TableViewSort') TableViewSort: MatSort;
  objectKeys = Object.values;
  objectKeys2 = Object.values;
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: any ;

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    // Create 100 users

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((events) => {
        this.authenticationService.currentUser.subscribe(
          (x) => (this.currentUser = x)
        );
      });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd');
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    });

    // Assign the data to the data source for the table to render

    this.Customer = [];
    this.ArrayDataReport2 = [];
    this.ArrayDataReport = new MatTableDataSource(null);
    this.columns = [];
    this.displayedColumns = [];
    this.viewTable = true;
    this.dataReportType={
      htmlDateFrom:0,
      htmlDateTo:0,
      htmlSearch:0,
      key:'R-INVENTORY',
      reports:'Report inventory available',
      reporteGenerar:''

    }
  }
  ngOnDestroy(): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';

    localStorage.setItem('header', '0');
  }

  ngOnInit(): void {
    this.To = this.date.value;
    this.From = this.date2.value;
    this.selected=Number(this.authenticationService.currentUserValue.customerId);
    if(this.authenticationService.currentUserValue.customerId!=""){
this.tab3=true



    }
  }
  ngAfterViewInit() {
    this.OnSelectCostumer();
    this.OnSelectTypeReports();
    this.viewTable = false;

    const main = <HTMLInputElement>document.getElementById('SubMenu');

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap((event) => {
          console.log('show');
          main.style.display = 'block';
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
        })
      )
      .subscribe((val) => {
        console.log('hide');
        main.style.display = 'none';
      });

    try {
      this.ArrayDataReport.paginator = this.TableViewPaginator;
      this.ArrayDataReport.sort = this.TableViewSort;
    } catch (error) {}
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.ArrayDataReport.filter = filterValue.trim().toLowerCase();

    if (this.ArrayDataReport.paginator) {
      this.ArrayDataReport.paginator.firstPage();
    }
  }
  OnSelectCostumer() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyId'] = json.companyIdWh;
    Request['active'] = '1';

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      })
      .subscribe((response: any) => {
        this.Customer = response;
      });
  }
  OnSelectTypeReports() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyId'] = Number(json.companyIdWh);

    this.http
      .post<any>(`${environment.apiUrl}/Reports/ReportsCompanyView`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      })
      .subscribe((response: ResponseTyperReports[]) => {
        this.typeReport = response;
      });
  }
  addEventfrom(type: string, event: MatDatepickerInputEvent<Date>) {
    this.From = event.value;
  }
  addEventto(type: string, event: MatDatepickerInputEvent<Date>) {
    this.To = event.value;
  }
  OnHtmlTypeReports(data: ResponseTyperReports) {
    this.viewTable = false;
    this.htmlDate = true;
    console.log(data);
    this.FromDate = false;
    this.ToDate = false;
    this.SearchIn = false;





    if (data.htmlDateFrom == 1) {
      this.FromDate = true;
    }

    if (data.htmlDateTo == 1) {
      this.ToDate = true;
    }

    if (data.htmlSearch == 1) {
      this.SearchIn = true;
    }
    this.DatosReporte = data;

  }
  OnSelectTypeReportsGenerated() {
    this.OnChangeLoader();
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

if(this.DatosReporte.key=='R-INVENTORY'){
  this.viewTable = false;
  this.http
    .get<any>(
      `${environment.apiUrl}/Administracion/WarehouseInventoryAvaliableSelectGet?customerID=${Number(this.selected)}`,
      
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token,
        }),
      }
    )
    .subscribe((response: any) => {
      try {
        this.displayedColumns =[];
        this.ArrayDataReport2=[];
     
        this.dtoptions=null;
        for (let index = 0; index < 1; index++) {
          this.displayedColumns = Object.keys(response[index]);
        }
        try {
          this.ArrayDataReport = new MatTableDataSource(response);
          this.ArrayDataReport2 = response;
          if (this.DatosReporte.key=="R-15"|| this.DatosReporte.key=="R-16"|| this.DatosReporte.key=="R-10") {
            this.dtoptions={
              pagingType: 'full_numbers',
              pageLength: 1000,
              processing: true,
              scrollX: true,
              scrollY: '70vh',
              dom: 'Bfrtip',
              order: [],
              buttons: [
                'colvis',
                'copy',
                {
                  extend: 'csvHtml5',
                  text: 'CSV',
                  exportOptions: {
                    modifier: {
                      search: 'applied',
                      selected: true,
                    },
                    columns: ':visible',
                  },
                },
                {
                  extend: 'print',
                  text: 'PDF',
                  exportOptions: {
                    modifier: {
                      search: 'applied',
                      selected: true,
                    },
                    columns: ':visible',
                  },
                },
              ],
              responsive: true,
              "columnDefs": [
                {
                    "targets": [ 0 ],
                    "visible": false,
                    "searchable": false
                }
            ]
            }
          } else {
            this.dtoptions={
              pagingType: 'full_numbers',
              pageLength: 1000,
              processing: true,
              scrollX: true,
              scrollY: '70vh',
              dom: 'Bfrtip',
              order: [],
              buttons: [
                'colvis',
                'copy',
                {
                  extend: 'csvHtml5',
                  text: 'CSV',
                  exportOptions: {
                    modifier: {
                      search: 'applied',
                      selected: true,
                    },
                    columns: ':visible',
                  },
                },
                {
                  extend: 'print',
                  text: 'PDF',
                  exportOptions: {
                    modifier: {
                      search: 'applied',
                      selected: true,
                    },
                    columns: ':visible',
                  },
                },
              ],
              responsive: true,
            }
          }
         try {
          this.ArrayDataReport.paginator = this.TableViewPaginator;
          this.ArrayDataReport.sort = this.TableViewSort;
         } catch (error) {
           
         }
          this.viewTable = true;
        } catch (error) {
          this.viewTable = false;
        }
      } catch (error) {
        this.viewTable = false;
      }
    });
}else{

    var Request = {};
    Request['typeReports'] = this.DatosReporte.key;
    Request['customerId'] = this.selected;
    Request['from'] = this.From;
    Request['to'] = this.To;
    Request['reports'] = this.DatosReporte.reporteGenerar;
    Request['Search'] = String(this.Searchtxt);
    this.viewTable = false;
    this.http
      .post<any>(
        `${environment.apiUrl}/Reports/ReportsCompanyGenerated`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response: any) => {
        try {
          this.displayedColumns =[];
          this.ArrayDataReport2=[];
       
          this.dtoptions=null;
          for (let index = 0; index < 1; index++) {
            this.displayedColumns = Object.keys(response[index]);
          }
          try {
            this.ArrayDataReport = new MatTableDataSource(response);
            this.ArrayDataReport2 = response;
            if (this.DatosReporte.key=="R-15"|| this.DatosReporte.key=="R-16"|| this.DatosReporte.key=="R-10") {
              this.dtoptions={
                pagingType: 'full_numbers',
                pageLength: 1000,
                processing: true,
                scrollX: true,
                scrollY: '70vh',
                dom: 'Bfrtip',
                order: [],
                buttons: [
                  'colvis',
                  'copy',
                  {
                    extend: 'csvHtml5',
                    text: 'CSV',
                    exportOptions: {
                      modifier: {
                        search: 'applied',
                        selected: true,
                      },
                      columns: ':visible',
                    },
                  },
                  {
                    extend: 'print',
                    text: 'PDF',
                    exportOptions: {
                      modifier: {
                        search: 'applied',
                        selected: true,
                      },
                      columns: ':visible',
                    },
                  },
                ],
                responsive: true,
                "columnDefs": [
                  {
                      "targets": [ 0 ],
                      "visible": false,
                      "searchable": false
                  }
              ]
              }
            } else {
              this.dtoptions={
                pagingType: 'full_numbers',
                pageLength: 1000,
                processing: true,
                scrollX: true,
                scrollY: '70vh',
                dom: 'Bfrtip',
                order: [],
                buttons: [
                  'colvis',
                  'copy',
                  {
                    extend: 'csvHtml5',
                    text: 'CSV',
                    exportOptions: {
                      modifier: {
                        search: 'applied',
                        selected: true,
                      },
                      columns: ':visible',
                    },
                  },
                  {
                    extend: 'print',
                    text: 'PDF',
                    exportOptions: {
                      modifier: {
                        search: 'applied',
                        selected: true,
                      },
                      columns: ':visible',
                    },
                  },
                ],
                responsive: true,
              }
            }
           try {
            this.ArrayDataReport.paginator = this.TableViewPaginator;
            this.ArrayDataReport.sort = this.TableViewSort;
           } catch (error) {
             
           }
            this.viewTable = true;
          } catch (error) {
            this.viewTable = false;
          }
        } catch (error) {
          this.viewTable = false;
        }
      });
    }
  }
  @ViewChild('excel') table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ); //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx');
  }
  OnChangeLoader() {
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 5000);
  }
}
